import PropTypes from 'prop-types'
import React from 'react'
import UserName from './UserName'

const rolesMap = {
  azubi: 'Azubi',
  ausbilder: 'Ausbilder',
  trainer: 'Trainer',
  fachausbilder: 'Fachausbilder',
}

class Profile extends React.Component {
  render() {
    const {userInfo, fallbackUsername} = this.props
    if (userInfo) {
      return (
        <div className="profile">
          <UserName userToDisplayInfo={userInfo} fallbackUsername={fallbackUsername} />
          <div data-testid="profile-role" className="profile__role">
            {rolesMap[userInfo.role] || userInfo.role}
          </div>
        </div>
      )
    }
    return null
  }
}

Profile.propTypes = {
  userInfo: PropTypes.shape({
    fullname: PropTypes.string,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    userId: PropTypes.number,
    role: PropTypes.string,
  }).isRequired,
  fallbackUsername: PropTypes.string,
}

export default Profile
